import Feed from './Feed';
import Login from './Login';
import NewPassword from './NewPassword';
import Profile from './Profile';
import Signup from './Signup';

export { Feed, Login, NewPassword, Profile, Signup };
